import React, { useState, useEffect } from 'react';
import MilitaryAd from "./mAdBind";
import CivilAd from "./cAdBind";
import './Aerodromes.css';

import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';


export default function Aerodromes() {
    return (
        <main>
            <Tabs defaultActiveKey="military" id="uncontrolled-tab-example" className=" aerodromesTabs">
                <Tab className="aerodromesTab" eventKey="military" title="Wojskowe">
                    <MilitaryAd />
                </Tab>
                <Tab eventKey="civil" title="Cywilne">
                    <CivilAd />
                </Tab>
            </Tabs>
        </main>
    )
}